export default "__VITE_ASSET__70f68bc7__"